import { evaluateLegacyExpression, getLegacyPath } from './legacyExpressions.mjs';

export { LegacyExpressionError, validateLegacyExpression, validateLegacyTemplate } from './legacyExpressions.mjs';

export function getByPath(path: unknown, data: unknown): any {
    return getLegacyPath(path, data);
}

export function evalBinding(binding: any, data: unknown): any {
    if (!binding) return '';
    const path = getByPath('path', binding);
    const expression = getByPath('expr', binding);
    const fallback = getByPath('fallback', binding);
    if (path) return getByPath(path, data) ?? fallback ?? '';
    if (expression) return runExpr(expression, data) ?? fallback ?? '';
    return fallback ?? '';
}

export function runExpr(expression: unknown, data: unknown): any {
    return evaluateLegacyExpression(expression, data);
}
